<template>
  <div class="h-screen flex vx-row items-center justify-center bg-auth"
    :class="{'w-full no-gutter': !isDesktop}"
    id="page-reset-password"
  >
    <div class="mobile-btn-back">
      <button v-if="!isDesktop" @click="onClose" class="btn-close">
        <feather-icon icon='XIcon'/>
      </button>
    </div>
    <vs-popup :title="$t('HELP_PRIVACY_POLICY').Title" :active.sync="displayPopupPrivacyPolicy" class="privacy-policy-modal" :class="{'privacy-policy-modal-mobile': !isDesktop}">
      <privacy-policy v-if="displayPopupPrivacyPolicy"></privacy-policy>
    </vs-popup>
    <vs-popup :title="$t('TERMS_USE').Title" :active.sync="displayPopupTermsCondition" class="terms-condition-modal" :class="{'terms-condition-modal-mobile': !isDesktop}">
      <terms-use :displayActionButton="false" v-if="displayPopupTermsCondition"></terms-use>
    </vs-popup>

    <div class="h-full">
      <VuePerfectScrollbar
        class="auth-content-scroll h-full"
        :settings="settings"
        :suppressScrollX="true"
      >
        <div class="items-center w-full">
          <div slot="no-body" class="full-page-bg-color">
            <div class="login-body">
              <div class="vx-col lg:block lg:w-1/1 mx-auto self-center logo-click" style="text-align: center;" @click="onClose">
                <vx-tooltip :text="$t('LOGIN').Click_Back" position="bottom" delay=".1s">             
                  <div class="logo-login mx-auto" :class="{'logo-login-mobile': !isDesktop}"></div>
                </vx-tooltip>
                <!-- <img src="@/assets/images/pages/login/padlock.svg" alt="login" class="mx-auto" v-if="isDesktop"> -->
                <!-- <div class="logo-login mx-auto logo-login-mobile" v-if="!isDesktop"></div> -->
              </div>
              <div class="w-full center">
                <h3>{{$t('RESET_PASSWORD').ResetTitle}}</h3>
              </div>
              <div class="pagecard">
                <!-- <vs-button type="flat" @click="onBack">Voltar</vs-button> -->
                <div class="" v-if="showForm">
                  <div class="vx-card__title m-5">
                    <p>{{$t('RESET_PASSWORD').ResetDesc}}</p>
                  </div>
                  <vs-input :name="$t('LOGIN').Password" v-validate.continues="'required|min:6|max:16'" ref="senha" type="password"
                          :label-placeholder="$t('RESET_PASSWORD').ResetPass" v-model="form.password1" class="w-full mb-3"/>
                  <span class="text-danger text-sm" v-show="errors.has($t('LOGIN').Password)">{{ errors.first($t('LOGIN').Password) }}</span>

                  <vs-input :name="$t('RESET_PASSWORD').Reset_Confirm" ref="alou" v-validate.continues="'required|min:6|max:16|confirmed:senha'"
                            type="password"
                            :label-placeholder="$t('RESET_PASSWORD').ResetConfirm"
                            v-model="form.password2"
                            class="w-full mb-3"/>
                  <span class="text-danger text-sm" v-show="errors.has($t('RESET_PASSWORD').Reset_Confirm)">{{ errors.first($t('RESET_PASSWORD').Reset_Confirm) }}</span>

                  <!-- <div class="flex flex-wrap justify-between flex-col-reverse sm:flex-row mt-5">
                    <vs-button type="border" :to="getStartPage" class="w-full sm:w-auto mb-8 sm:mb-auto mt-3 sm:mt-auto">
                      {{$t('BUTTONS').BackLogin}}
                    </vs-button>
                    <vs-button class="w-full sm:w-auto" @click="onResetPassword">
                      {{$t('BUTTONS').Send}}
                    </vs-button>
                  </div> -->
                  
                  <div class="flex flex-row-reverse">
                      <vs-button @click="onResetPassword" class="btn-login">{{$t('BUTTONS').Send}}</vs-button>
                  </div>
                  
                  
                </div>
                <div class="" v-else>
                  <div class="vx-card__title mb-8">
                    <h4 class="mb-5">{{$t('RESET_PASSWORD').PasswordChanged}}</h4>
                    <p>{{$t('RESET_PASSWORD').PasswordChangedDesc}}</p>
                  </div>
                  <div class="flex flex-wrap justify-between flex-col-reverse sm:flex-row mt-5">
                    <vs-button type="border" :to="getStartPage" class="w-full sm:w-auto mb-8 sm:mb-auto mt-3 sm:mt-auto">
                      {{$t('BUTTONS').BackLogin}}
                    </vs-button>
                  </div>
                </div>
                <auth-links :login="false" :register="false" :lostAccess="true"></auth-links>
              </div>
              <auth-footer-privacy
                @open-terms="displayPopupTermsCondition = !displayPopupTermsCondition"
                @open-privacy="displayPopupPrivacyPolicy = !displayPopupPrivacyPolicy"
              ></auth-footer-privacy>
            </div>
          </div>
        </div>
      </VuePerfectScrollbar>
    </div>

   
  </div>
</template>

<script>
  import jwt_decode from 'jwt-decode';
  import messagesNotifyHelper from '../../helpers/messages-notify-helper';
  import userService from "../../providers/userService";
  import AppConstants from '../../appConstants';
  import { getCodeLang } from '../../helpers/locale-helper';
  import AuthFooterPrivacy from './AuthFooterPrivacy.vue';
  import TermsUse from './help/TermsUse.vue';
  import PrivacyPolicy from './help/PrivacyPolicy.vue';
  import AuthLinks from './AuthLinks.vue';
  import VuePerfectScrollbar from "vue-perfect-scrollbar";

  export default {
    components: {
      AuthFooterPrivacy,
      TermsUse,
      PrivacyPolicy,
      AuthLinks,
      VuePerfectScrollbar
    },
    data() {
      return {
        showForm: true,
        form: {
          token: '',
          password1: '',
          password2: '',
        },
        settings: {
          maxScrollbarLength: 60,
          wheelSpeed: 0.3,
          swipeEasing: true
        },
        displayPopupTermsCondition: false,
        displayPopupPrivacyPolicy: false,
      }
    },
    mounted() {
      const token = this.$route.query.token;

      try {
        // Check if there is an e-mail and client is true
        const jwtDecode = jwt_decode(token);
        console.log(jwtDecode)
        // if (!jwtDecode.email || !jwtDecode.client) {
        if (!jwtDecode.email) {
          throw "Invalid";
        }

        // change lang page
        if (jwtDecode.lang) {
          this.$i18n.locale = getCodeLang(jwtDecode.lang);
        }
      } catch (e) {
        let error = {
          message: this.$t('CHANGE_PASSWORD').InvalidToken
        };
        messagesNotifyHelper.handleError(error);
      }

      this.form.token = token;
    },
    computed: {
      isDesktop() {
        return this.$store.state.isDesktop;
      },
      getStartPage() {
        return `${AppConstants.NAVIGATION_PAGE_LOGIN}`;
      }
    },
    methods: {
      onClose() {
        this.$router.push(AppConstants.NAVIGATION_PAGE_HOME);
      },
      sendEmail () {
        userService.sendPassword(this.form, new URLSearchParams())
          .then(response => {
            console.log("==> Response: ", response);
            this.showForm = false;
          })
          .catch(() => {});
      },
      onResetPassword() {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.sendEmail();
          } else {
            messagesNotifyHelper.errorNotify(this.$t('RESET_PASSWORD').Notify_Title, this.$t('RESET_PASSWORD').Notify_Error_Message);
          }
        });

      },
    },
  }
</script>
